export default function (writeList) {
  const scoreMethod = this.dictMap['BOE35']
  const scoreType = Object.keys(scoreMethod).map(item => ({
    label: scoreMethod[item],
    value: item
  }))
  return [
    {
      type: 'Select',
      title: '打分方式',
      [$field]: 'scoringMethod',
      optionList: scoreType,
      rules: ['required']
    },
    {
      type: 'textarea',
      title: '打分说明（供参与打分的人员查看）',
      [$field]: 'scoreExplain',
      colSpan: 24,
      props: {
        maxlength: 500
      },
      rules: ['required']
    },
    {
      type: 'Checkbox',
      title: '回写更新字段',
      colSpan: 12,
      [$field]: 'writeBackFields',
      optionList: writeList,
      rules: ['required']
    }
  ]
}